import React, { useState, useRef, useEffect } from 'react';
import './MultiSelectDropdown.css';

const MultiSelectDropdown = ({ 
  options, 
  selectedValues, 
  onChange, 
  placeholder = "Select options",
  required = false,
  name,
  otherValue = '',
  onOtherChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionChange = (value) => {
    const newSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter(item => item !== value)
      : [...selectedValues, value];
    
    onChange(newSelectedValues);
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) {
      return placeholder;
    }
    if (selectedValues.length === 1) {
      return selectedValues[0];
    }
    return `${selectedValues.length} options selected`;
  };

  return (
    <div className="multiselect-dropdown" ref={dropdownRef}>
      <div 
        className={`multiselect-trigger ${isOpen ? 'open' : ''}`}
        onClick={handleToggle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        <span className={`multiselect-text ${selectedValues.length === 0 ? 'placeholder' : ''}`}>
          {getDisplayText()}
        </span>
        <span className={`multiselect-arrow ${isOpen ? 'open' : ''}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </span>
      </div>
      
      {isOpen && (
        <div className="multiselect-dropdown-menu">
          <div className="multiselect-options">
            {options.map((option, index) => (
              <label key={option} className="multiselect-option">
                <input
                  type="checkbox"
                  checked={selectedValues.includes(option)}
                  onChange={() => handleOptionChange(option)}
                  className="multiselect-checkbox"
                />
                <span className="multiselect-checkmark"></span>
                <span className="multiselect-option-text">{option}</span>
              </label>
            ))}
          </div>
        </div>
      )}
      
      {/* Show text input when "Other" is selected */}
      {selectedValues.includes('Other') && (
        <div className="other-text-input-container">
          <input
            type="text"
            placeholder="Please specify..."
            value={otherValue}
            onChange={(e) => onOtherChange && onOtherChange(e.target.value)}
            className="other-text-input"
          />
        </div>
      )}
      
      {/* Hidden input for form validation */}
      <input
        type="hidden"
        name={name}
        value={selectedValues.join(',')}
        required={required && selectedValues.length === 0}
      />
    </div>
  );
};

export default MultiSelectDropdown; 